import styled from 'styled-components';

import { ContainerStyled } from '~/Components/Styled';

export const Container = styled(ContainerStyled)``;
